// extracted by mini-css-extract-plugin
export default {"sysbar":"SystemBar_sysbar__9pysx","amp":"SystemBar_amp__amIzT"};